import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserContainerComponent } from './user-container.component';
import { UserListComponent } from './components/userList/user-list.component';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import {MatListModule} from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UserService } from './services/user/user.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreateUserComponent } from './components/createUser/create-user.component';
import { EditUserComponent } from './components/editUser/edit-user.component';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ResetPasswordReqVM } from 'src/app/viewModels/resetPassword/reset-password-req-vm';
import { FlexLayoutModule } from '@angular/flex-layout';
import { clickableColumns } from 'src/app/middleware/common/clickableColumns';
//import { RoleService } from '../roles/services/role.service';
import { ApiEndPointsUser } from './common/apiUrls/api-end-points';
//import { ApiEndPointsRoles } from '../roles/components/apiURLs/api-end-points';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserprofileUpdateVM } from 'src/app/viewModels/users/userprofile-update-vm';
import { MatRadioModule } from '@angular/material/radio';
import { SignaturePadModule } from 'ngx-signaturepad';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
//import {MatMomentDateModule} from '@angular/material-moment-adapter';
import { ClipboardModule } from '@angular/cdk/clipboard'
const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [UserContainerComponent,UserListComponent, CreateUserComponent, EditUserComponent, UserProfileComponent, SideNavigationComponent],
  imports: [
    CommonModule,
    UserRoutingModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatSliderModule,
    FlexLayoutModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTabsModule,
    MatChipsModule,
    MatListModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatCheckboxModule,
    NgxMaskModule.forRoot(maskConfig),
    SharedModule,
    MatTooltipModule,
    MatRadioModule,
    MatSlideToggleModule,
    SignaturePadModule,
    MatDatepickerModule,
    ClipboardModule
    //MatMomentDateModule
  ],
  providers: [
    UserService,
    ApiEndPointsUser,
    Constants,
    //DataSharingService,
    PaginationViewModel,
    StatusConstant,
    ResetPasswordReqVM,
    clickableColumns,
    //RoleService,
    //ApiEndPointsRoles,
    UserprofileUpdateVM
  ]
})
export class UserModule { }
